import { useMutation } from '@apollo/client'
import { useDispatch } from 'react-redux'

import { setBanner } from 'src/store/action-methods/banner'

import { ADD_SHARE_LINK_VISITORS } from 'src/graphql/board/shareLink'

interface VisitorProps {
  boardId: string
  tokenId: string
}

export const useAddShareLinkVisitor = ({ boardId, tokenId }: VisitorProps) => {
  const dispatch = useDispatch()
  const [addShareLinkVisitorMutation] = useMutation(ADD_SHARE_LINK_VISITORS)

  const addShareLinkVisitor = async () => {
    try {
      await addShareLinkVisitorMutation({
        variables: { boardId, tokenId }
      })
    } catch (_) {
      setBanner({
        open: true,
        error: true,
        msg: 'We were unable to add share link visitor. Please try again in a few minutes.',
        assertive: true
      })(dispatch)
    }
  }

  return { addShareLinkVisitor }
}
